module.exports = __webpack_public_path__ + "88dc226e5248a0f72c2bd176ceacf898.gltf";